__turbopack_context__.v({
  "animatedPath": "styles-module-scss-module__Fogsva__animatedPath",
  "dash": "styles-module-scss-module__Fogsva__dash",
  "wrapper": "styles-module-scss-module__Fogsva__wrapper",
});
